import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { comAddPageFieldFunc, onChangeCheckbox, onChangeSelect, onChangeText } from '../../../../../components/Common/validationFunction'
import { Breadcrumb_inputName, editItemId, get_Category_By_CategoryType_ForDropDownAPI } from '../../../../../store/actions'
import Select from "react-select"
import { unitConversionInitial } from '../../ItemMaster/itemIndex'
import { mode } from '../../../../../routes'
import { customAlert } from '../../../../../CustomAlert/ConfirmDialog'
import { IsSweetAndSnacksCompany } from '../../../../../components/Common/CommonFunction'

const BasicInfoTabForm = ({ state, setState, settable, pageField, pageMode }) => {

    const dispatch = useDispatch();
    // const [unitTableData, setUnitTableData] = useState([]);

    const [isHover, setIsHover] = React.useState(false);
    const [isPressed, setIsPressed] = React.useState(false);
    const [searchResults, setSearchResults] = React.useState([]);

    const {
        BaseUnit,
        CategoryTypeList,
        CategoryList,
        BrandName,
        ItemTagList,
        listBtnLoading
    } = useSelector((state) => ({
        BaseUnit: state.ItemMastersReducer.BaseUnit,
        CategoryTypeList: state.categoryTypeReducer.categoryTypeListData,
        CategoryList: state.ItemMastersReducer.Category,
        categotyDropDownLoading: state.ItemMastersReducer.categotyDropDownLoading,
        BrandName: state.GeneralReducer.GeneralMasterSubType,
        ItemTagList: state.ItemMastersReducer.ItemTagList,
        listBtnLoading: state.ItemMastersReducer.listBtnLoading,
    }));

    const { values } = state;
    const { isError } = state;
    const { fieldLabel } = state;
    const isEditMode = values?.id ? true : false;
    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster;
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    const BaseUnit_DropdownOptions = BaseUnit.map((data) => ({
        value: data.id,
        label: data.Name
    }));

    const CategoryTypeList_DropdownOptions = CategoryTypeList.map((data) => ({
        value: data.id,
        label: data.Name,
    }));

    const CategoryList_DropdownOptions = CategoryList.map((data) => ({
        value: data.id,
        label: data.Name,
    }));

    const BrandName_DropdownOptions = BrandName.map((data) => ({
        value: data.id,
        label: data.Name,
    }));

    function CategoryType_Handler(hasSelect, evn,) {
        onChangeSelect({ hasSelect, evn, state, setState })
        dispatch(get_Category_By_CategoryType_ForDropDownAPI(hasSelect.value))

        setState((i) => {
            const a = { ...i }
            a.values.Category = [];
            a.hasValid.Category.valid = false
            return { ...a }
        })
    }

    function BaseUnitOnchange(hasSelect, evn) {
        onChangeSelect({ hasSelect, evn, state, setState });


        const additionalUnits = [];

        if (hasSelect.value !== 1) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 1, label: 'No' }, Conversion: 1, IsBase: false, id: 2 });
        }
        if (hasSelect.value !== 2) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 2, label: 'Kg' }, Conversion: 1, IsBase: false, id: 3 });
        }
        if (hasSelect.value !== 4) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 4, label: 'Box' }, Conversion: 1, IsBase: false, id: 4 });
        }

        if (state.values.BaseUnitName?.value !== hasSelect.value) {
            settable([
                { ...unitConversionInitial, IsBase: true, Conversion: 1, Unit: hasSelect },
                ...additionalUnits
            ]);
        }
    }


    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        try {
            var x = document.getElementById("itemtag");
            if (event.target == "") {
                var x = document.getElementById("itemtag");
                x.style.display = "none";
            }
        } catch (w) { }
    }

    let data = ItemTagList.map((index) => {
        return index.dta
    })

    function handleChange(event) {

        try {
            onChangeText({ event, state, setState })
            dispatch(Breadcrumb_inputName(event.target.value));
            // CommonTab_SimpleText_INPUT_handller_ForAll(event.target.value, "Name")
            var searchtext = event.target.value
            const results = data.filter(person =>
                person.toLowerCase().includes(searchtext)
            );

            setSearchResults(results);

            var x = document.getElementById("itemtag");
            document.addEventListener('click', function handleClickOutsideBox(event) {
                if (!x.contains(event.target)) {
                    x.style.display = 'none';
                }
            });

            x.style.display = "block";
            var di = "100Px"

            if (event.target.value == "") {
                di = `${x.style.display = "none"}`
            }
            else if (results.length == 0) {
                di = `${x.style.display = "none"}`
            }
            else if (results.length < 2) {
                di = "50Px"
            } else if (results.length > 5) {
                di = "300Px"
            } else if (results.length < 2) {
                di = "50Px"
            }
            x.style.height = di;

        } catch (w) { }
    };

    const onclickselect = function () {
        const hasNone = document.getElementById("itemtag").style;

        if (hasNone.display === "none") {
            hasNone.display = "block";
        } else {
            hasNone.display = "none";
        }
    };

    const fetchSAPItem = () => {
        const sapCode = values.SAPItemCode?.trim();
        if (!sapCode) {
            customAlert({
                Type: 4,
                Message: "Please Enter SAP Code"
            });
            return;
        }

        dispatch(editItemId({
            editId: sapCode,
            btnmode: "edit",
            isFetch: true
        }));

    }

    const FirstTab = (
        <div id={"base-tabe-area"}>
            <Card className="text-black"  >
                <CardBody className="c_card_body">

                    <Col md={12} >
                        <Row className="mt-1 ">
                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.Name ? fieldLabel.Name : "Name"} </Label>
                                <Input
                                    name="Name"
                                    id="txtName"
                                    value={values.Name}
                                    type="text"
                                    className={isError.Name.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.Name}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onClick={onclickselect}
                                    onChange={(e) => { handleChange(e) }}
                                />
                                {isError.Name.length > 0 && (
                                    <span className="invalid-feedback">{isError.Name}</span>
                                )}
                                <div id="itemtag" >
                                    <ul style={{}}>
                                        {searchResults.map(item => (
                                            <li className="liitem" >{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.ShortName ? fieldLabel.ShortName : "Short Name"} </Label>
                                <Input
                                    name="ShortName"
                                    id="txtName"
                                    value={values.ShortName}
                                    type="text"
                                    className={isError.ShortName.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.ShortName}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onChange={(event) => {
                                        onChangeText({ event, state, setState })
                                    }}
                                />
                                {isError.ShortName.length > 0 && (
                                    <span className="invalid-feedback">{isError.ShortName}</span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.ShelfLife ? fieldLabel.ShelfLife : "Shelf Life"}<samp className="text-secondary">/Day</samp> </Label>
                                <Input
                                    name="ShelfLife"
                                    id="txtName"
                                    value={values.ShelfLife}
                                    type="text"
                                    className={isError.ShelfLife.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.ShelfLife}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onChange={(event) => {
                                        onChangeText({ event, state, setState })
                                    }}
                                />
                                {isError.ShelfLife.length > 0 && (
                                    <span className="invalid-feedback">{isError.ShelfLife}</span>
                                )}
                            </FormGroup>
                        </Row>
                    </Col>

                    <Col md={12} >
                        <Row className="mt-1 ">
                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.BaseUnitName ? fieldLabel.BaseUnitName : "Base Unit"} </Label>
                                <Select
                                    name="BaseUnitName"
                                    value={values.BaseUnitName}
                                    isSearchable={true}
                                    isDisabled={pageMode === mode.edit}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={BaseUnit_DropdownOptions}
                                    onChange={BaseUnitOnchange}
                                />
                                {isError.BaseUnitName.length > 0 && (
                                    <span className="text-danger f-8"><small>{isError.BaseUnitName}</small></span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.BarCode ? fieldLabel.BarCode : "BarCode"} </Label>
                                <Input
                                    name="BarCode"
                                    id="txtName"
                                    value={values.BarCode}
                                    type="text"
                                    className={isError.BarCode.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.BarCode}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onChange={(event) => {
                                        onChangeText({ event, state, setState })
                                    }}
                                />
                                {isError.BarCode.length > 0 && (
                                    <span className="invalid-feedback">{isError.BarCode}</span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.SAPItemCode ? fieldLabel.SAPItemCode : "SAP Code"} </Label>
                                <div className="input-group">
                                    <Input
                                        name="SAPItemCode"
                                        id="txtName"
                                        value={values.SAPItemCode}
                                        type="text"
                                        className={isError.SAPItemCode.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder={`Please Enter ${fieldLabel.SAPItemCode}`}
                                        autoComplete='off'
                                        autoFocus={true}
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                            
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                fetchSAPItem();
                                            }
                                        }}
                                    />
                                    {IsSweetAndSnacksCompany() && pageMode === mode.defaultsave && (
                                        <button
                                        type="button"
                                        onClick={fetchSAPItem}
                                        disabled={listBtnLoading || isEditMode}
                                    
                                        onMouseDown={() => setIsPressed(true)}
                                        onMouseUp={() => setIsPressed(false)}
                                        onMouseLeave={() => {
                                            setIsPressed(false);
                                            setIsHover(false);
                                        }}
                                        onMouseEnter={() => setIsHover(true)}
                                    
                                        style={{
                                            all: "unset", // 🔥 reset bootstrap completely
                                            backgroundColor: isHover ? "#4347a5" : "#5156be", // 🔥 main + hover
                                            color: "#ffffff",
                                            border: "1px solid #5156be",
                                            borderLeft: "none",
                                            padding: "0 16px",
                                            height: "38px",
                                            borderRadius: "0 8px 8px 0",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            cursor: (listBtnLoading || isEditMode) ? "not-allowed" : "pointer",
                                            transform: isPressed && !listBtnLoading ? "scale(0.96)" : "scale(1)",
                                            boxShadow: isHover ? "0 2px 6px rgba(37, 99, 235, 0.25)" : "none",
                                            transition: "all 0.15s ease",
                                            opacity: (listBtnLoading || isEditMode) ? 0.7 : 1,
                                            userSelect: "none"
                                        }}
                                    >
                                        {listBtnLoading ? (
                                            <>
                                                <span
                                                    style={{
                                                        width: "14px",
                                                        height: "14px",
                                                        border: "2px solid #cbd5f5",
                                                        borderTop: "2px solid #0f172a",
                                                        borderRadius: "50%",
                                                        animation: "spin 0.6s linear infinite"
                                                    }}
                                                />
                                                Fetching...
                                            </>
                                        ) : (
                                            "Fetch"
                                        )}
                                    </button>
                                    )}
                                </div>
                                {isError.SAPItemCode.length > 0 && (
                                    <span className="invalid-feedback">{isError.SAPItemCode}</span>
                                )}
                            </FormGroup>
                        </Row>
                    </Col>

                    <Col md={12} >
                        <Row className="mt-1 ">
                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.CategoryType ? fieldLabel.CategoryType : "Category Type"} </Label>
                                <Select
                                    name="CategoryType"
                                    value={values.CategoryType}
                                    isSearchable={true}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={CategoryTypeList_DropdownOptions}
                                    onChange={CategoryType_Handler}
                                />
                                {isError.CategoryType.length > 0 && (
                                    <span className="text-danger f-8"><small>{isError.CategoryType}</small></span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.Category ? fieldLabel.Category : "Category"} </Label>
                                <Select
                                    name="Category"
                                    value={values.Category}
                                    isMulti={true}
                                    isSearchable={true}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={CategoryList_DropdownOptions}
                                    onChange={(hasSelect, evn) => {
                                        onChangeSelect({ hasSelect, evn, state, setState })
                                    }}
                                />
                                {isError.Category.length > 0 && (
                                    <span className="text-danger f-8"><small>{isError.Category}</small></span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.BrandName ? fieldLabel.BrandName : "Brand Name"}</Label>
                                <Select
                                    name="BrandName"
                                    value={values.BrandName}
                                    isMulti={true}
                                    isSearchable={true}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={BrandName_DropdownOptions}
                                    onChange={(hasSelect, evn) => {
                                        onChangeSelect({ hasSelect, evn, state, setState })
                                    }}
                                />
                                {isError.BrandName.length > 0 && (
                                    <span className="text-danger f-8"><small>{isError.BrandName}</small></span>
                                )}
                            </FormGroup>
                        </Row>
                    </Col>

                    <Col md={12} >
                        <Row className="mt-1 ">

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.Tag ? fieldLabel.Tag : "Tag"} </Label>
                                <Input
                                    name="Tag"
                                    id="txtName"
                                    value={values.Tag}
                                    type="text"
                                    className={isError.Tag.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.Tag}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onChange={(event) => {
                                        onChangeText({ event, state, setState })
                                    }}
                                />
                                {isError.Tag.length > 0 && (
                                    <span className="invalid-feedback">{isError.Tag}</span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3 col col-sm-4 " >
                                <Label >{fieldLabel.Sequence ? fieldLabel.Sequence : "Sequence"} </Label>
                                <Input
                                    name="Sequence"
                                    id="txtName"
                                    value={values.Sequence}
                                    type="text"
                                    className={isError.Sequence.length > 0 ? "is-invalid form-control" : "form-control"}
                                    placeholder={`Please Enter ${fieldLabel.Sequence}`}
                                    autoComplete='off'
                                    autoFocus={true}
                                    onChange={(event) => {
                                        onChangeText({ event, state, setState })
                                    }}
                                />
                                {isError.Sequence.length > 0 && (
                                    <span className="invalid-feedback">{isError.Sequence}</span>
                                )}
                            </FormGroup>

                            {/* IsCBMItem */}
                            <FormGroup className="mb-1 col col-sm-2 ">
                                <Row style={{ marginTop: '25px' }}>
                                    <Label className="col-sm-5 col-form-label">
                                        {fieldLabel.IsCBMItem ? fieldLabel.IsCBMItem : "IsCBMItem"}
                                    </Label>
                                    <Col md={4} style={{ marginTop: '7px' }} className="form-check form-switch form-switch-sm">
                                        <div className="form-check form-switch form-switch-md mb-3">
                                            <Input
                                                name="IsCBMItem"
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={values.IsCBMItem}
                                                onChange={(event) => onChangeCheckbox({ event, state, setState })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </FormGroup>

                       
                           

                        </Row>
                    </Col>

                    <Col md={12} >
                        <Row className="mt-n3 ">
                            <FormGroup className="mb-1 col col-sm-4 " >
                                <Row style={{ marginTop: '25px' }}>
                                    <Label
                                        className="col-sm-4 col-form-label">
                                        {fieldLabel.isActive ? fieldLabel.isActive : "isActive"}
                                    </Label>
                                    <Col md={4} style={{ marginTop: '7px' }} className=" form-check form-switch form-switch-sm ">
                                        <div className="form-check form-switch form-switch-md mb-3">
                                            <Input
                                                name="isActive"
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={values.isActive}
                                                onChange={(event) => onChangeCheckbox({ event, state, setState })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup className="mb- col col-sm-4 " >
                                <Row style={{ marginTop: '25px' }}>
                                    <Label
                                        className="col-sm-4 col-form-label">
                                        {fieldLabel.IsSCM ? fieldLabel.IsSCM : "IsSCM"}
                                    </Label>
                                    <Col md={4} style={{ marginTop: '7px' }} className=" form-check form-switch form-switch-sm ">
                                        <div className="form-check form-switch form-switch-md mb-3">
                                            <Input
                                                name="IsSCM"
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={values.IsSCM}
                                                onChange={(event) => onChangeCheckbox({ event, state, setState })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup className="mb-1 col col-sm-2 ">
                                <Row style={{ marginTop: '25px' }}>
                                    <Label className="col-sm-5 col-form-label">
                                        {fieldLabel.IsMixItem ? fieldLabel.IsMixItem : "IsMixItem"}
                                    </Label>
                                    <Col md={4} style={{ marginTop: '7px' }} className="form-check form-switch form-switch-sm">
                                        <div className="form-check form-switch form-switch-md mb-3">
                                            <Input
                                                name="IsMixItem"
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={values.IsMixItem}
                                                onChange={(event) => onChangeCheckbox({ event, state, setState })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </FormGroup>

                        </Row>
                    </Col>
                </CardBody>
            </Card>

        </div >
    )
    return FirstTab
}

export default BasicInfoTabForm



